/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BaseStateResponseDto>;
export function request(body: defs.basics.BaseStateRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseState/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
